/* eslint-disable prefer-promise-reject-errors */
import axios from 'axios';

const types = {
  LOGIN: 'LOGIN',
  LOGIN_FULFILLED: 'LOGIN_FULFILLED',
  LOGIN_REJECTED: 'LOGIN_REJECTED',
  CLEAR_LOGIN_STATUS: 'CLEAR_LOGIN_STATUS'
};

function doPostLogin() {
  let data = {};
  return axios.post('/api/kerberosusertoken')
      .then((response) => {
        data = response;
        return axios.post('/userPrivileges', { token: response.data.access_token });
      }).then((privResponse) => {
        data.data.privileges = privResponse.data;
        return data.data;
      })
      .catch((error) => {
      const response = { data: {} };
        response.type = 'applicaiton/json';
        if (error.response.data.error.code === '500 INTERNAL_SERVER_ERROR') {
          response.data.error = 'server issue';
          response.data.invalidLicense = true;
          response.data.msg = error.response.data.error.displayMessage;
        } else {
          response.data.error = 'server issue';
          response.data.invalidLicense = false;
          response.data.msg = '';
        }

        response.status = 500;
        // eslint-disable-next-line no-promise-executor-return
        return new Promise((res, rej) => rej({ response }));
      });
}

function postLogin() {

  const plAction = {
    type: 'API',
    types: [types.LOGIN, types.LOGIN_FULFILLED, types.LOGIN_REJECTED],
    api: doPostLogin,
    kerberos: true
  };
  return plAction;
}

function clearLoginStatus() {
  return {
    type: types.CLEAR_LOGIN_STATUS
  };
}

const actions = {
  postLogin,
  clearLoginStatus
};

export {
  types,
  actions
};